/**
 * Store Modification Observer
 */
export default {
    state: {
        change: false,
    },

    mutations: {
        /**
         * Initialise le state change
         */
        setChange: function (state, change) {
            state.change = change
        }
    },

    actions: {
        modificationDetected: function (context) {
            context.commit('setChange', true)
        },

        resetModification: function (context) {
            context.commit('setChange', false)
        }
    },

    getters: {
        hasModification: state => {
            return state.change
        },
    }
}
